import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import {
  ADD_SHIPPER,
  DELETE_SHIPPER,
  GET_SHIPPER,
} from "../../../helpers/url_api_constant";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Modal,
  Row,
} from "reactstrap";
import ConfirmDialog, {
  useConfirmDialog,
} from "../../../components/Custom/ConfirmDialog";
import { Link, useHistory } from "react-router-dom";
import MessageDialog, {
  useModalShowMessage,
} from "../../../components/Custom/MessageDialog";
import React, { useEffect, useState } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import Loading from "../../../components/Custom/Loading";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getPermission } from "../../../helpers/auth_helper";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../../helpers/api_helper";
//i18n
import { withTranslation } from "react-i18next";

function Shipper(props) {
  //การกด link ไปหน้าอื่น //
  let history = useHistory();
  //การกด link ไปหน้าอื่น //

  const searchObj = { FULL_NAME: "", CONTACT_CODE: "" };
  const createObj = { PID: "", FULL_NAME: "", CONTACT_CODE: "" };
  const permission = getPermission();
  const [readonly, setReadonly] = useState(false)
  const [pageAdd, setPageAdd] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [userActionType, setUserActionType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();

  //ฝั่งซ้ายคือ ตัวแปล ฝั่งขวา คือ ฟังก์ชั่น Ex  modelDeviceList เป็น ตัวแปลที่ใช้ ส่วน  setModelDeviceListเป็น ฟังก์ชั่นที่ใช้ Set Value ให้ modelDeviceList

  // const listData = [
  //   {
  //     Id: "1",
  //     ShipperName: "EGAT",
  //     ShipperCode: "A1002",
  //     MainContact: "Mock Data",
  //     ShipperE_mail: "MockData@gmail.com",
  //     ShipperTel: "08x-xxx-xxxx",
  //   },

  //   {
  //     Id: "2",
  //     ShipperName: "PTT",
  //     ShipperCode: "A1003",
  //     MainContact: "Mock Data",
  //     ShipperE_mail: "MockData001@gmail.com",
  //     ShipperTel: "09x-xxx-xxxx",
  //   },
  // ];

  // const listPerson = [
  //   {
  //     PersonId: "1",
  //     Name: "Jai Deeja",
  //     E_mail: "JaiDeeja@gmail.com",
  //     Phone: "080-xxx-xxxx",
  //   },

  //   {
  //     PersonId: "2",
  //     Name: "Somsak Mockdata",
  //     E_mail: "SomsakMockdata@gmail.com",
  //     Phone: "095-xxx-xxxx",
  //   },
  // ];

  //sort Column//
  const defaultSorted = [
    {
      dataField: "FULL_NAME",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div>
        <OverButton
          onClick={() => {
            setReadonly(true);
            onEdit(row);
            setUserActionType("(View)");
          }}
          color="primary"
          icon="fas fa-eye"
          label="View"
        />
        <OverButton
          onClick={() => {
            gotoPagePerson(row);
          }}
          color="info"
          icon="fas fa-users"
          label="Person"
        />
        {permission.eSHP && (
          <>
            <OverButton
              onClick={() => {
                setReadonly(false);
                onEdit(row);
                setUserActionType("(Edit)");
              }}
              color="info"
              icon="far fa-edit"
              label="Edit"
            />
            <OverButton
              onClick={() => {
                onDelete(row);
              }}
              color="danger"
              icon="fas fa-trash-alt"
              label="Delete"
            />
          </>
        )}
      </div>
    );
  };

  const gotoPagePerson = row => {
    // console.log(row);
    history.push("/shipper/" + row.PID + "/person");
  };

  // Action Button//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "4%",
        fontSize: "12px",
      },
      style: {
        width: "4%",
        fontSize: "12px",
      },
      formatter: CountIndexRow,
    },
    {
      dataField: "FULL_NAME",
      text: "Shipper Name",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "CONTACT_CODE",
      text: "Shipper Code",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "PRIORITY_FLAG",
      text: "Order",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "7%",
        fontSize: "12px",
      },
      style: {
        width: "7%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "CONCT_ALIAS_NAME",
      text: "Main Contact",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "CONCT_EMAIL",
      text: "Shipper E-mail",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "CONCT_TEL",
      text: "Tel",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "14%",
        fontSize: "12px",
      },
      style: {
        width: "14%",
        fontSize: "12px",
      },
      sort: true,
    },

    {
      dataField: "df1",
      text: "Action",
      headerAlign: "center",
      align: "center",
      isDummyField: true,
      headerStyle: {
        width: "13%",
        fontSize: "12px",
      },
      style: {
        width: "13%",
        fontSize: "12px",
      },
      formatter: ButtonAction,
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    resetSearch();
    resetModel();

    ///fixed header table
    let tableId = "shipper-table";
    let scrollY = 233;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const onAdd = () => {
    setReadonly(false);
    resetModel();
    setPageAdd(true);
    setUserActionType("(Add Record)");
  };

  const onEdit = row => {

    setCreateModel(row);
    setPageAdd(true);
  };

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const validateForm = () => {
    let bResult = true;
    if (createModel.FULL_NAME == "") {
      bResult = false;
    }

    if (createModel.CONTACT_CODE == "") {
      bResult = false;
    }
    return bResult;
  };

  // อันนี้เขียนแบบ async , await
  const fetchData = async (searchData) => {
    setIsLoading(true);
    try {
      let res = await post(GET_SHIPPER, searchData);
      // console.log(res);
      setModelDeviceList(res.data.customerList);

    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  const saveData = async () => {
    if (validateForm()) {
      setIsLoading(true);
      try {
        let res = await post(ADD_SHIPPER, createModel);
        // console.log(res);
        if (res.resultCode == 200) {
          res.isEditMode == 0 ? toggleModalMessage("Save success.") : toggleModalMessage("Update success.");
          setPageAdd(false);
          fetchData(searchModel);
        } else {
          toggleModalMessage(res.resultDescription);
        }
      } catch (err) {
        toggleModalMessage(err.message);
      }
      setIsLoading(false);
    }
  };

  const deleteData = async () => {
    setIsLoading(true);
    try {
      let res = await post(DELETE_SHIPPER, createModel);
      toggleConfirm();
      if (res.resultCode == 200) {
        toggleModalMessage("Delete success.");
        fetchData(searchModel);
      } else {
        toggleModalMessage(res.message);
      }
      setIsLoading(false);
    } catch (err) {
      toggleConfirm();
      toggleModalMessage(err.message);
      setIsLoading(false);
    }
  };

  //Function CURL

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Shipper")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Master Data Setting
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Shipper</li>
                      </ol>
                    </div>
                  </div>
                  <hr />
                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-0">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Shipper Name
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Shipper Name")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    FULL_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.FULL_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-0">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Shipper Code
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Shipper Code")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    CONTACT_CODE: e.target.value,
                                  })
                                }
                                value={searchModel.CONTACT_CODE}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row">
                        <div className="d-grid gap-2 d-md-block">
                          <Button
                            color="info"
                            className="mt-0"
                            onClick={() => onSearch()}>
                            <i className="fas fa-search"></i>
                            &nbsp; Search
                          </Button>

                          <Button
                            color="warning"
                            className="mt-0 ms-2"
                            onClick={() => resetSearch()}>
                            <i className="fas fa-redo-alt"></i>
                            &nbsp; Reset
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mb-2 mt-2">
                    <Col sm="3">
                      <div className="d-grid gap-2 d-md-block">
                        {permission.eSHP && (
                          <Button
                            onClick={() => onAdd()}
                            // className="btn-rounded"
                            color="success"
                            className="mt-2 mb-1"
                          >
                            <i className="fas fa-plus"></i>
                            &nbsp; Add
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <div>
                        {/* className="table-responsive" */}
                        <BootstrapTable
                          keyField="PID"
                          id="shipper-table"
                          data={modelDeviceList}
                          columns={columns}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          defaultSorted={defaultSorted}
                          pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/*start : ModalPageAdd */}
      <Modal size="lg" isOpen={pageAdd}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Shipper {userActionType}
          </h5>
        </div>
        <div className="modal-body">
          <CardBody>
            <AvForm className="needs-validation">
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Shipper Name
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // style={{ border: "solid 1px #FFFFFF" }}
                      // readOnly={readonly}
                      // disabled={readonly}
                      disabled={readonly == true}
                      name="FULL_NAME"
                      type="text"
                      errorMessage="Enter Shipper Name"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          FULL_NAME: e.target.value,
                        })
                      }
                      value={createModel.FULL_NAME}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="row mb-3">
                  <Label className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Shipper Code
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // style={{ border: "solid 1px #FFFFFF" }}
                      // readOnly={readonly}
                      disabled={userActionType == "(Edit)" || readonly}
                      name="CONTACT_CODE"
                      type="text"
                      errorMessage="Enter Shipper Code"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          CONTACT_CODE: e.target.value,
                        })
                      }
                      value={createModel.CONTACT_CODE}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="row mb-3">
                  <Label className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Shipper Order
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // style={{ border: "solid 1px #FFFFFF" }}
                      // readOnly={readonly}
                      disabled={readonly}
                      name="PRIORITY_FLAG"
                      type="number"
                      min="0"
                      errorMessage="Enter Shipper Order"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          PRIORITY_FLAG: e.target.value,
                        })
                      }
                      value={createModel.PRIORITY_FLAG}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <div className="text-center mt-2">
                {!readonly &&
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => saveData()}
                  >
                    <i className="far fa-save"></i> Save
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setPageAdd(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </AvForm>
          </CardBody>
          {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#556ee6" }}
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#556ee6" }}
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-success">Save</button>
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/*end : PageAdd */}

      {/*Loading */}
      <Loading show={isLoading} />
      {/*Loading */}

      {/* MessageDialog */}
      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />
      {/* comfirmDialog */}
      <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      />
    </React.Fragment>
  );
}

Shipper.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ Shipper }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Shipper));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
